import React, { useEffect, useState} from 'react';
import { Form, Input, Button, Row, Col, Select, Breadcrumb, Collapse, Divider, Card,Popconfirm,Space } from "antd";
import { useDispatch } from 'react-redux';
import AddEditUserDialog from './AddEditUserDialog';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import userService from '../../services/user-service';
import CustomTable from '../../components/table/custom-table';
import * as Icon from "react-feather";
import constantService from '../../services/constant-service';

const { Panel } = Collapse;
const { Option } = Select;


const UserManagement = (props) => {
    
    const dispatch = useDispatch();
    const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
    const [editData, setEditData] = useState(null);
    const [condition, setCondition] = useState({firstName: null, lastName: null, email: null, telNo: null, userRole: null, status: null});
    const [dataList, setDataList] = useState([]);
    const [pagination, setPagination] = useState({currentPage: 1,rowPerPage: 10,rowCount: 0 });
    const [statusList, setStatusList] = useState([]);
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
		async function initData() {
			const { userStatus } = await constantService.getUserStatus();
			setStatusList(userStatus);

            const { userRole } = await constantService.getUserRole();
			setRoleList(userRole);
		}
		initData();
        doSearch(1);
	}, []);

    const onAdd = () => {
		setIsShowAddFileDialog(true);
		setEditData(null);
	};

    const onCancel= () => {
		setIsShowAddFileDialog(false);
		setEditData(null);
	};

    const onSaveComplete = () => {
		setIsShowAddFileDialog(false);
		doSearch(1);
	};

    const onEdit = (data) =>{
        setEditData(data);
        setIsShowAddFileDialog(true);
    }

    const renderUserStatusOptions = () => {
		const result = statusList.map((item, index) => {
			if (item.value !== 'Z') {
				return (
					<Option key={index} value={item.value} name="status">
						{item.labelEn}
					</Option>
				);
			}
		});
		return result;
	};

    const renderRole = () => {
		const result = roleList.map((item, index) => {
            if (item.value !== 'OTHER') {
                return (
                    <Option key={index} value={item.value} name="userRole">
                        {item.labelEn}
                    </Option>
                );
            }
		});
		return result;
	};

    const onChangeCondition = (event) => {
        const { name, value } = event.target;
        setCondition({ ...condition, [name]: value });
    }

    const onChangeSelect = (name) => {
       	return (value) => {
            setCondition({ ...condition, [name]: value });
		};
    }

    const onClearSearch = () =>{
        setCondition({firstName: null, lastName: null, email: null, telNo: null, userRole: '', status: ''});
    }

    const doSearch = async (currentPage) => {
        try {
            const newPaginate = {
                ...pagination,
                currentPage: currentPage ? currentPage : pagination.currentPage,
            };

            dispatch(appLoaderAction.enable());

            const result = await userService.search(condition, newPaginate);
            
            setDataList(result.list);
            setPagination(result.pagination ? result.pagination : newPaginate);
            dispatch(appLoaderAction.disale());
        } catch (err) {
            dispatch(appLoaderAction.disale());
            dispatch(notifyUtitls.error(err));
        }
	};

    const onChangePage = (currentPage) =>{
       doSearch(currentPage);
    }

    const columns = [
        {
            align: 'left',
            title: 'ชื่อ',
            key: 'firstName',
            render: ({ profile }) => {
                return <span>{profile.firstName}</span>;
            },
        },
        {
            align: 'left',
            title: 'นามสกุล',
            key: 'lastName',
            render: ({ profile }) => {
                return <span>{profile.lastName}</span>;
            },
        },
        {
            align: 'left',
            title: 'อีเมล',
            key: 'email',
            render: ({ profile }) => {
                return <span>{profile.email}</span>;
            },
        },
        {
            align: 'left',
            title: 'เบอร์โทรศัพท์',
            key: 'telNo',
            render: ({ profile }) => {
                return <span>{profile.telNo}</span>;
            },
        },
        {
            align: 'left',
            title: 'สิทธิการใช้งาน',
            key: 'userRole',
            dataIndex: 'userRole',
            render: (data) => {
                let userRole = roleList.find((item) => item.value === data);
                if (userRole) {
                    let labelEn = userRole.labelEn;
                    return <span>{labelEn}</span>; 
                }
            },
        },
        {
            align: 'left',
            title: 'สถานะ',
            key: 'status',
            dataIndex: 'status',
            render: (data) => {
                let status = statusList.find((item) => item.value === data);
                if (status) {
                    let labelEn = status.labelEn;
                    return <span>{labelEn}</span>; 
                }
            },
        },{
            title: 'ดำเนินการ',
            key: 'action',
            fixed: 'right',
            width: 100,
            render: ({ userId }) => (
                <Space size="middle">
                    <a onClick={() => onClickEdit(userId)} className="pe-3 border-end">
                        <Icon.Edit size={18} />
                    </a>
                                  
                    <Popconfirm
                        title="ยืนยันการลบข้อมูล ?"
                        onConfirm={() => onConfirmDelete(userId)}
                        okText="ยืนยัน"
                        cancelText="ยกเลิก" >
                        <a >
                            <Icon.Trash size={18} />
                        </a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const onConfirmDelete = (id)  => {
        onDelete(id);
    }

    const onClickEdit = async (id) => {
        try {
            dispatch(appLoaderAction.enable());

            const editData = await userService.getById({id: id});
            onEdit(editData.bean);

            dispatch(appLoaderAction.disale());
        } catch (err) {
            dispatch(appLoaderAction.disale());
            notifyUtitls.error(err);
        }
	}

    const onDelete = async (id) => {
        try {
            dispatch(appLoaderAction.enable());
            await userService.remove({deleteId: id});
            dispatch(appLoaderAction.disale());
            notifyUtitls.success('Delete', 'Deleted Successfully');
            doSearch(1);
        } catch (err) {
            dispatch(appLoaderAction.disale());
            notifyUtitls.error(err);
        }
	};

    
    return (
        <div>
            <h2 className="color-primary-title">การจัดการผู้ใช้งาน</h2>
            <Breadcrumb>
                <Breadcrumb.Item>ผู้ดูแลระบบ</Breadcrumb.Item>
                <Breadcrumb.Item>จัดการผู้ใช้งาน</Breadcrumb.Item>
            </Breadcrumb>
            <Divider className="mt-2 mb-4" />

            <div className="d-flex justify-content-between">
                <div>
                    <Button type="primary" className="mx-2" htmlType="button" onClick={() => onAdd()}>
                        <Icon.Plus className="me-1" size={18} /> เพิ่มผู้ใช้งาน
                    </Button>
                </div>
            </div>

            <Card className="mt-4" bordered={false}>
                <Collapse className="mb-4" defaultActiveKey={['1']} >
                    <Panel header="ตัวกรอง" key="1" className="search-panel">
                        <Form wrapperCol={{ span: 22 }} layout="vertical">
                            <Row>
                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="ชื่อ"  className="mb-0">
                                        <Input
                                            name="firstName"
                                            value={condition.firstName}
                                            onChange={onChangeCondition}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="นามสกุล">
                                        <Input
                                            name="lastName"
                                            value={condition.lastName}
                                            onChange={onChangeCondition}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="อีเมล">
                                        <Input
                                            name="email"
                                            value={condition.email}
                                            onChange={onChangeCondition}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="เบอร์โทรศัพท์">
                                        <Input
                                            name="telNo"
                                            value={condition.telNo}
                                            onChange={onChangeCondition}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="สิทธิการใช้งาน" initialValue="">
                                        <Select name="userRole" value={condition.userRole} onChange={onChangeSelect('userRole')}>
                                            {renderRole()}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8} xxl={{ span: 4, offset: 4 }}>
                                    <Form.Item label="สถานะ" initialValue="">
                                        <Select name="status" value={condition.status} onChange={onChangeSelect('status')}>
                                            {renderUserStatusOptions()}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <div>
                                <Button type="primary" className="mx-2" onClick={() => doSearch(1)}>
                                    <Icon.Search className="me-1" size={18} />ค้นหา
                                </Button>
                                <Button className="btn-gray ms-2" onClick={() => onClearSearch()}>ล้างค่า</Button>
                            </div>
                        </Form>
                    </Panel>
                </Collapse>

                <CustomTable
                    rowKey="userId"
                    tableName="userTable"
                    columns={columns}
                    data={dataList}
                    scroll={{ x: true }}
                    isPagination={true}
                    onChangePage={onChangePage}
                    currentPage={pagination.currentPage}
                    pageSize={pagination.rowPerPage}
                    totalRecord={pagination.rowCount}
                />
            </Card>
            <AddEditUserDialog 
                        isShow={isShowAddFileDialog}
                        editData={editData}
                        onCancel={onCancel}
                        onSaveComplete={onSaveComplete}></AddEditUserDialog>
        </div>
    )

}

export default UserManagement;